import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetofivejyotilingadarshancabs() {



  const cardData =
  {
    keyword: ' Pune to 5 Jyotirlinga Darshan Cab',
    heading: 'Sai Trupti Cabs: Pune to 5 Jyotirlinga Darshan Cab',
    headingDescription: 'Sai Trupti Cabs offers comfortable and devotional Pune to 5 Jyotirlinga Darshan cab services, designed for a peaceful and spiritually fulfilling pilgrimage. Our well-maintained fleet of air-conditioned Sedans, SUVs, and Tempo Travellers ensures a smooth and comfortable journey to all five sacred Jyotirlingas — Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. With professional, background-verified chauffeurs who are experienced in long-distance routes, we guarantee punctual departures, safe driving, and courteous service throughout your holy trip. Each vehicle is equipped with spacious seating, clean interiors, and modern amenities to make your multi-day pilgrimage truly comfortable.',

    top: 'Top Places to Visit in 5 Jyotirlinga with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga – Nashik",
    "description": "Nestled at the foothills of the Brahmagiri Mountains near Nashik, Trimbakeshwar Jyotirlinga is one of the most sacred shrines of Lord Shiva. The temple, built in classic Nagara style, houses a unique three-faced Shiva Linga symbolizing Brahma, Vishnu, and Mahesh. Surrounded by the holy Godavari River, devotees believe that visiting Trimbakeshwar cleanses sins and grants moksha. The temple’s serene environment, spiritual energy, and sacred water tanks make it a divine destination for pilgrims across India."
  },
  {
    "title": "Bhimashankar Jyotirlinga – Pune",
    "description": "Located in the Sahyadri ranges near Pune, Bhimashankar Jyotirlinga sits amidst lush forests and misty hills. The temple’s ancient Nagara-style architecture and natural surroundings create a deeply spiritual aura. According to legend, Lord Shiva manifested here to defeat the demon Tripurasura, marking it as a site of immense power. Bhimashankar also serves as the origin of the Bhima River. Pilgrims and trekkers alike are enchanted by its divinity, natural beauty, and the rich biodiversity of the surrounding wildlife sanctuary."
  },
  {
    "title": "Grishneshwar Jyotirlinga – Aurangabad",
    "description": "Grishneshwar Jyotirlinga, located near the UNESCO-listed Ellora Caves in Aurangabad, is the twelfth and final Jyotirlinga of Lord Shiva. The temple’s stunning red basalt stone carvings and tall shikhara reflect traditional Maratha architecture. Devotees believe that offering prayers here fulfills heartfelt wishes and brings prosperity. The temple is closely tied to the legend of Ghushma, a devotee blessed by Lord Shiva himself. Its proximity to Ellora makes it both a spiritual and historical marvel for pilgrims and travelers."
  },
  {
    "title": "Aundha Nagnath Jyotirlinga – Hingoli",
    "description": "Aundha Nagnath Jyotirlinga in Hingoli district is considered the first among the twelve Jyotirlingas and is believed to have been worshipped by the Pandavas. The temple’s 13th-century Hemadpanthi architecture, massive stone pillars, and intricate carvings showcase the brilliance of ancient artisans. The Shiva Linga here represents eternal energy and devotion. Surrounded by tranquil landscapes, Aundha Nagnath offers devotees a powerful blend of faith, history, and architectural grandeur in the heart of rural Maharashtra."
  },
  {
    "title": "Parli Vaijnath Jyotirlinga – Beed",
    "description": "Parli Vaijnath Jyotirlinga, located in Beed district, is a temple steeped in mythological and healing significance. Legends say Lord Shiva here cured the demon king Ravana, symbolizing compassion and restoration. The temple’s black stone structure, elevated steps, and serene surroundings evoke deep reverence. Pilgrims come seeking not only blessings but also relief from suffering and ailments. Parli Vaijnath stands as a spiritual beacon of divine mercy and faith in the sacred heart of Maharashtra."
  }
],



"services": [
  {
    "name": "Pune to 5 Jyotirlinga Darshan Cab",
    "description": "Pune to 5 Jyotirlinga Darshan Cab offers a comfortable and reliable travel option for pilgrims visiting the 5 Jyotirlingas from Pune. Services include air-conditioned vehicles, professional drivers, online booking, transparent fares, real-time ride tracking, and 24/7 support for a smooth spiritual journey."
  },
  {
    "name": "Pune to 5 Jyotirlinga Taxi",
    "description": "Pune to 5 Jyotirlinga Taxi provides convenient taxi services for one-way or round trips to the 5 Jyotirlinga temples. Features include experienced chauffeurs, spacious AC vehicles, online booking, fare transparency, and 24/7 assistance."
  },
  {
    "name": "Pune to Jyotirlinga Car Hire",
    "description": "Pune to Jyotirlinga Car Hire offers flexible car rental options for self-drive or chauffeur-driven trips to the Jyotirlingas. Benefits include air-conditioned vehicles, reliable drivers, online booking, transparent fares, and 24/7 customer support."
  },
  {
    "name": "Pune to 5 Jyotirlinga One Way Cab",
    "description": "Pune to 5 Jyotirlinga One Way Cab provides seamless one-way travel to the 5 Jyotirlinga temples with comfortable AC vehicles, professional drivers, online booking, transparent fares, and real-time ride tracking for a stress-free journey."
  },
  {
    "name": "Pune to 5 Jyotirlinga Drop Taxi",
    "description": "Pune to 5 Jyotirlinga Drop Taxi ensures safe and reliable door-to-door drop service for pilgrims. Services include air-conditioned vehicles, experienced drivers, online booking, fare transparency, and 24/7 customer support."
  },
  {
    "name": "Pune to 5 Jyotirlinga Ertiga Cab",
    "description": "Pune to 5 Jyotirlinga Ertiga Cab offers spacious and comfortable travel with air-conditioned interiors, professional chauffeurs, online booking, transparent fares, real-time ride tracking, and 24/7 assistance, ideal for families and small groups."
  },
  {
    "name": "Pune to 5 Jyotirlinga Innova Cab",
    "description": "Pune to 5 Jyotirlinga Innova Cab provides premium travel in a spacious and comfortable Innova vehicle. Features include professional drivers, air-conditioning, online booking, transparent fares, real-time ride tracking, and 24/7 support."
  },
  {
    "name": "Affordable Pune to 5 Jyotirlinga Cab",
    "description": "Affordable Pune to 5 Jyotirlinga Cab offers budget-friendly travel options without compromising comfort. Includes air-conditioned vehicles, professional drivers, online booking, transparent fares, and 24/7 customer support."
  },
  {
    "name": "Pune to 5 Jyotirlinga Luxury Cab",
    "description": "Pune to 5 Jyotirlinga Luxury Cab provides a premium travel experience with high-end vehicles, professional chauffeurs, air-conditioning, online booking, transparent fares, real-time ride tracking, and 24/7 assistance for a luxurious journey."
  },
  {
    "name": "Pune to 5 Jyotirlinga Outstation Cab",
    "description": "Pune to 5 Jyotirlinga Outstation Cab ensures reliable long-distance travel to the Jyotirlinga temples with spacious AC vehicles, professional drivers, online booking, transparent fares, real-time ride tracking, and 24/7 support."
  },
  {
    "name": "Pune to 5 Jyotirlinga Sedan Cab",
    "description": "Pune to 5 Jyotirlinga Sedan Cab offers comfortable travel in air-conditioned sedans with professional drivers, online booking, transparent fares, and 24/7 customer support for one-way or round trips."
  },
  {
    "name": "Pune to 5 Jyotirlinga AC Cab",
    "description": "Pune to 5 Jyotirlinga AC Cab provides a comfortable, air-conditioned ride for pilgrims traveling from Pune to the Jyotirlingas. Features include professional chauffeurs, online booking, transparent fares, real-time tracking, and 24/7 support."
  },
  {
    "name": "Pune to 5 Jyotirlinga Online Booking",
    "description": "Pune to 5 Jyotirlinga Online Booking allows hassle-free cab reservations through a digital platform. Offers instant confirmation, multiple vehicle options, transparent fares, real-time tracking, and 24/7 customer assistance."
  },
  {
    "name": "Pune to 5 Jyotirlinga Cab Service",
    "description": "Pune to 5 Jyotirlinga Cab Service provides comprehensive travel solutions including one-way trips, round trips, and outstation journeys with air-conditioned vehicles, professional drivers, online booking, transparent fares, and 24/7 assistance."
  },
  {
    "name": "Pune to 5 Jyotirlinga Tour Taxi",
    "description": "Pune to 5 Jyotirlinga Tour Taxi specializes in pilgrimage tours, providing a comfortable AC ride with experienced chauffeurs, door-to-door service, online booking, fare transparency, and 24/7 support for an organized spiritual journey."
  }
],
"tableData": [
  ["Pune to 5 Jyotirlinga Darshan Cab", "Pune to 5 Jyotirlinga Taxi"],
  ["Pune to Jyotirlinga Car Hire", "Pune to 5 Jyotirlinga One Way Cab"],
  ["Pune to 5 Jyotirlinga Drop Taxi", "Pune to 5 Jyotirlinga Ertiga Cab"],
  ["Pune to 5 Jyotirlinga Innova Cab", "Affordable Pune to 5 Jyotirlinga Cab"],
  ["Pune to 5 Jyotirlinga Luxury Cab", "Pune to 5 Jyotirlinga Outstation Cab"],
  ["Pune to 5 Jyotirlinga Sedan Cab", "Pune to 5 Jyotirlinga AC Cab"],
  ["Pune to 5 Jyotirlinga Online Booking", "Pune to 5 Jyotirlinga Cab Service"],
  ["Pune to 5 Jyotirlinga Tour Taxi", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to 5 Jyotirlinga Darshan Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers a dedicated cab service for the sacred ‘Pune to 5 Jyotirlinga’ pilgrimage — covering the five revered temples in Maharashtra from your starting point in Pune."
  },
  {
    "WhyChooseheading": "Complete & Spiritual Route Coverage",
    "WhyChoosedescription": "Our package is designed to cover the five major Jyotirlinga temples (Bhimashankar Jyotirlinga, Trimbakeshwar Jyotirlinga, Grishneshwar Jyotirlinga, Aundha Nagnath Jyotirlinga and Parli Vaijnath Jyotirlinga) from Pune, so you don’t need to arrange different transfers. :contentReference[oaicite:5]{index=5}"
  },
  {
    "WhyChooseheading": "Comfortable Vehicle Options",
    "WhyChoosedescription": "Choose from sedans, SUVs or premium cars depending on your group size and comfort requirements — ideal for the long‑distance pilgrimage route. For example, Ertiga at ~₹15/km, Innova Crysta at ~₹20/km. :contentReference[oaicite:6]{index=6}"
  },
  {
    "WhyChooseheading": "Transparent & Competitive Pricing",
    "WhyChoosedescription": "Our fare structure is clear and competitive for faith‑based travel. You’ll receive a detailed cost estimate (km rate, driver allowance, toll/parking extras) before your journey. :contentReference[oaicite:7]{index=7}"
  },
  {
    "WhyChooseheading": "Professional Drivers Experienced on the Route",
    "WhyChoosedescription": "Our drivers are trained and familiar with all five temple locations and the routes from Pune — ensuring you arrive safely, on‑time and with minimal fuss."
  },
  {
    "WhyChooseheading": "Flexible Trip Duration & Custom Stops",
    "WhyChoosedescription": "You can choose a 3‑5 day itinerary (or longer) based on your pace and rest preferences — with stops at each temple and comfortable transitions between them. :contentReference[oaicite:8]{index=8}"
  },
  {
    "WhyChooseheading": "Well‑Maintained, Clean & Sanitized Vehicles",
    "WhyChoosedescription": "Our fleet is regularly serviced and cleaned, ensuring you have a comfortable ride for the long haul covering multiple destinations."
  },
  {
    "WhyChooseheading": "24/7 Booking & Support for the Tour",
    "WhyChoosedescription": "Our team is available round‑the‑clock to assist you with pick‑up planning, route changes, overnight stays and any on‑trip queries."
  }
]



































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to 5 Jyotirlinga Darshan cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to 5 Jyotirlinga Darshan cab services for spiritual tours, one way, and round trips.',
  },
  {
    question: 'How can I book a Pune to 5 Jyotirlinga Darshan cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to 5 Jyotirlinga Darshan cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available for Pune to 5 Jyotirlinga Darshan?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cabs to suit your group size, comfort needs, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to 5 Jyotirlinga Darshan trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance and spiritual tour routes, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Pune to 5 Jyotirlinga Darshan for group or family trips?',
    answer: 'Certainly. Our cab services cater to family trips, group tours, and spiritual journeys from Pune to the 5 Jyotirlinga temples.',
  },
  {
    question: 'Is the Pune to 5 Jyotirlinga Darshan cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune to 5 Jyotirlinga Darshan tours for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Pune to 5 Jyotirlinga Darshan cab fares?',
    answer: 'Our cab fares start from ₹5,500 for sedans, ₹6,500–₹8,500 for SUVs and Innova Crysta, depending on vehicle type, group size, and itinerary.',
  },
  {
    question: 'What payment options are accepted for Pune to 5 Jyotirlinga Darshan cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to 5 Jyotirlinga Darshan cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Pune to 5 Jyotirlinga Darshan cab journey?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to 5 Jyotirlinga Darshan trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashok Deshmukh',
    feedback: 'I booked a Pune to 5 Jyotirlinga Darshan cab with Sai Trupti Cabs. The trip was smooth, and the driver was courteous and knowledgeable about the temples.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Patil',
    feedback: 'Sai Trupti Cabs provided excellent service for our 5 Jyotirlinga Darshan tour from Pune. Comfortable vehicle and timely service.',
    rating: 5,
  },
];






























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to 5 Jyotirlinga Darshan Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-5-jyotirlinga-cab.jpg",
  "description": "Book Pune to 5 Jyotirlinga Darshan Cab with Sai Trupti Cabs for a comfortable and safe pilgrimage. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation trips with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-5-jyotirlinga-darshan-cab"
  }
};





  return (
    <div>
      <Helmet>
  <title>Pune to 5 Jyotirlinga Darshan Cab | Comfortable Pilgrimage | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to 5 Jyotirlinga Darshan Cab with Sai Trupti Cabs for a comfortable and safe pilgrimage. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation trips with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Pune to 5 Jyotirlinga Darshan Cab, Pune to 5 Jyotirlinga Taxi, Pune to Jyotirlinga Car Hire, Pune to 5 Jyotirlinga One Way Cab, Pune to 5 Jyotirlinga Drop Taxi, Pune to 5 Jyotirlinga Ertiga Cab, Pune to 5 Jyotirlinga Innova Cab, Affordable Pune to 5 Jyotirlinga Cab, Pune to 5 Jyotirlinga Luxury Cab, Pune to 5 Jyotirlinga Outstation Cab, Pune to 5 Jyotirlinga Sedan Cab, Pune to 5 Jyotirlinga AC Cab, Pune to 5 Jyotirlinga Online Booking, Pune to 5 Jyotirlinga Cab Service, Pune to 5 Jyotirlinga Tour Taxi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetofivejyotilingadarshancabs;